import React, { Component } from "react";
import { Modal, Form, Row, Col, Button, Tooltip, Icon, InputNumber } from "antd";
import InputForm from "./InputForm";
import axios from 'axios';
import "./Form.css";
import MunicipioFrame from './MunicipioFrame';

const { Item: ItemForm } = Form;

export const OPCOES_COMBO_REGIME = [
  { key: '1', label: '1 CONTRIBUINTE' },
  { key: '2', label: '2 ISENTO (CONTRIBUINTE SEM IE)' },
  { key: '9', label: '9 NÃO CONTRIBUINTE' },
]

export const OPCOES_COMBO_TIPO_PROD = [
  { key: '1', label: '1 REVENDA' },
  { key: '2', label: '2 FABRICAÇÃO PRÓPRIA' },
]


export default class ParametroNFeCFOPForm extends Component {
  state = {
    registro: {
      pcfop_idf: 0,
      pcfop_cfop_dentro_uf: { key: '' },
      pcfop_cfop_fora_uf: { key: '' },
      pcfop_cfop_estrangeiro: { key: '' },
      pcfop_tipo_mov_nf: { key: '' },
      pcfop_regime_contribuinte: { key: '' },
      pcfop_natureza: { key: '' },
      pcfop_municipio: {
        key: '0',
        label: '',
        cmun_uf: '0',
        cuf_sigla: '',
      },
      pcfop_tipo_produto: { key: '' },
    },
  };


  componentDidUpdate(propsAnterior, stateAnterior) {
    if (this.props.registroSelecionado !== propsAnterior.registroSelecionado) {
      this.setState({
        registro: this.props.registroSelecionado
      }, () => {
        this.onBuscaTipoMovNF();
        this.onBuscaNatOper();
      });
    }
  }



  onOK = () => {

    const reg = {
      pcfop_idf: this.state.registro.pcfop_idf,
      pcfop_cfop_dentro_uf: this.state.registro.pcfop_cfop_dentro_uf.key ? String(this.state.registro.pcfop_cfop_dentro_uf.key) : '',
      pcfop_cfop_fora_uf: this.state.registro.pcfop_cfop_fora_uf.key ? String(this.state.registro.pcfop_cfop_fora_uf.key) : '',
      pcfop_cfop_estrangeiro: this.state.registro.pcfop_cfop_estrangeiro.key ? String(this.state.registro.pcfop_cfop_estrangeiro.key) : '',
      pcfop_tipo_mov_nf: this.state.registro.pcfop_tipo_mov_nf.key ? String(this.state.registro.pcfop_tipo_mov_nf.key) : '',
      pcfop_regime_contribuinte: this.state.registro.pcfop_regime_contribuinte.key ? String(this.state.registro.pcfop_regime_contribuinte.key) : '',
      pcfop_natureza: this.state.registro.pcfop_natureza.key ? this.state.registro.pcfop_natureza.key : 0,
      pcfop_municipio: this.state.registro.pcfop_municipio.key ? String(this.state.registro.pcfop_municipio.key) : '',
      pcfop_tipo_produto: this.state.registro.pcfop_tipo_produto.key ? this.state.registro.pcfop_tipo_produto.key : 0,
    };

    this.props.onSalvarClick(reg);
  };


  onBuscaTipoMovNF = async () => {
    this.setState({ OPCOES_COMBO_TIPO_MOV_NF: [] })
    axios.get('/tipoMovNF/lista')
      .then(response => {
        const { data } = response;
        const OPCOES_COMBO_TIPO_MOV_NF = data.map(regList => {
          return {
            key: String(regList.tmnf_idf),
            label: regList.tmnf_descricao,
          }
        });
        this.setState({
          OPCOES_COMBO_TIPO_MOV_NF,
        })
      }).catch(error => {
        console.error(error.response);
      })
  };

  onBuscaNatOper = async () => {
    this.setState({ OPCOES_COMBO_CFOP: [] })
    axios.get('/cfop/lista')
      .then(response => {
        const { data } = response;
        const OPCOES_COMBO_CFOP = data.map(regList => {
          return {
            key: String(regList.cfop_codigo),
            label: String(regList.cfop_codigo) + ' - ' + regList.cfop_descricao,
          }
        });
        this.setState({
          OPCOES_COMBO_CFOP,
        })
      }).catch(error => {
        console.error(error.response);
      })
  };

  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;
    const { registro } = this.state;
    registro[id] = value;
    this.setState({ [id]: value });
  };

  onChangeMunicipio = event => {
    const { registro } = this.state;
    registro['pcfop_municipio'] = event.pcfop_municipio;
    this.setState(event);
  }




  render() {
    const { onCancelarClick, carregando, visivel } = this.props;
    const { OPCOES_COMBO_CFOP, OPCOES_COMBO_TIPO_MOV_NF } = this.state;
    const { pcfop_idf, pcfop_cfop_dentro_uf, pcfop_cfop_fora_uf, pcfop_cfop_estrangeiro, pcfop_tipo_mov_nf, pcfop_regime_contribuinte, pcfop_natureza, pcfop_municipio, pcfop_tipo_produto
    } = this.state.registro;

    // console.log('ParametroNFeCFOPForm.this.state: ', this.state);

    const uploadButton = (
      <div>
        {this.state.loading ? <Icon type="loading" style={{ color: 'rgba(0,0,0,0.4)' }} /> : <Icon type="plus" style={{ color: 'rgba(0,0,0,0.4)' }} />}
        <div className="ant-upload-text">Logo</div>
      </div>
    );

    return (
      <Modal
        title={pcfop_idf ? "Edição de Parâmetros CFOP NFe" : "Cadastro de Parâmetros CFOP NFe"}
        visible={visivel}
        destroyOnClose
        onCancel={onCancelarClick}
        footer={null}
        width={"40%"}
        style={{ top: 30 }}
      >
        <Form>
          <Row>

            <Col xs={24} sm={8} style={{ paddingRight: 10 }}>
              <span>CFOP Dentro UF</span>
              <InputForm
                type="select"
                id="pcfop_cfop_dentro_uf"
                ref="pcfop_cfop_dentro_uf"
                value={pcfop_cfop_dentro_uf}
                placeholder="Selecione o CFOP"
                onChange={this.onChange}
                data={OPCOES_COMBO_CFOP}
                validator={value => Boolean(value)}
                style={{ width: "100%" }}
                showSearch
              />
            </Col>

            <Col xs={24} sm={8} style={{ paddingRight: 10 }}>
              <span>CFOP Fora UF</span>
              <InputForm
                type="select"
                id="pcfop_cfop_fora_uf"
                ref="pcfop_cfop_fora_uf"
                value={pcfop_cfop_fora_uf}
                placeholder="Selecione o CFOP"
                onChange={this.onChange}
                data={OPCOES_COMBO_CFOP}
                validator={value => Boolean(value)}
                style={{ width: "100%" }}
                showSearch
              />
            </Col>

            <Col xs={24} sm={8} style={{}}>
              <span>CFOP Estrangeiro</span>
              <InputForm
                type="select"
                id="pcfop_cfop_estrangeiro"
                ref="pcfop_cfop_estrangeiro"
                value={pcfop_cfop_estrangeiro}
                placeholder="Selecione o CFOP"
                onChange={this.onChange}
                data={OPCOES_COMBO_CFOP}
                validator={value => Boolean(value)}
                style={{ width: "100%" }}
                showSearch
              />
            </Col>

            <Col xs={24} sm={12} style={{ marginTop: -20, paddingRight: 10 }}>
              <span>Tipo Nota Fiscal</span>
              <InputForm
                type="select"
                id="pcfop_tipo_mov_nf"
                ref="pcfop_tipo_mov_nf"
                value={pcfop_tipo_mov_nf}
                placeholder="Selecione o Tipo"
                onChange={this.onChange}
                data={OPCOES_COMBO_TIPO_MOV_NF}
                validator={value => Boolean(value)}
                style={{ width: "100%" }}
              />
            </Col>


            <Col xs={24} sm={12} style={{ marginTop: -20 }}>
              <span>Regime Contribuinte</span>
              <InputForm
                type="select"
                id="pcfop_regime_contribuinte"
                ref="pcfop_regime_contribuinte"
                value={pcfop_regime_contribuinte}
                placeholder="Selecione o Tipo"
                onChange={this.onChange}
                data={OPCOES_COMBO_REGIME}
                validator={value => Boolean(value)}
                style={{ width: "100%" }}
              />
            </Col>

            <Col xs={24} sm={12} style={{ marginTop: -20, paddingRight: 10 }}>
              <span>Tipo Produto</span>
              <InputForm
                type="select"
                id="pcfop_tipo_produto"
                ref="pcfop_tipo_produto"
                value={pcfop_tipo_produto}
                placeholder="Selecione o Tipo"
                onChange={this.onChange}
                data={OPCOES_COMBO_TIPO_PROD}
                validator={value => Boolean(value)}
                style={{ width: "100%" }}
              />
            </Col>

            <Col xs={24} sm={12} style={{ marginTop: -20 }}>
              <MunicipioFrame
                label="Município"
                id="pcfop_municipio"
                value={pcfop_municipio}
                width={"100%"}
                onChange={this.onChangeMunicipio}
                descricaoPrimeiroItem="Todos os Municípios"
              />
            </Col>

          </Row>

          <ItemForm>
            <Row>
              <Col xs={24}>
                <Button
                  type="primary"
                  htmlType="button"
                  loading={carregando}
                  onClick={this.onOK}
                  className="btn-salvar"
                >
                  Salvar
                </Button>

                <Button
                  htmlType="button"
                  onClick={onCancelarClick}
                  className="btn-fechar"
                >
                  Fechar
                </Button>
              </Col>
            </Row>
          </ItemForm>

        </Form>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ParametroNFeCFOPForm.js